import { Card, CardContent, Typography } from "@mui/material";
import dayjs from "dayjs";
import {
  Area,
  AreaChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { ITimeSeriesEntry } from "../../types";

interface TimeSeriesChartProps {
  data: ITimeSeriesEntry[];
}

function formatDate(raw: string): string {
  return dayjs(raw, "YYYYMMDD").format("DD/MM");
}

export function TimeSeriesChart({ data }: TimeSeriesChartProps) {
  const chartData = data.map((entry) => ({
    date: formatDate(entry.date),
    sessions: entry.sessions,
  }));

  return (
    <Card sx={{ height: "100%" }}>
      <CardContent>
        <Typography variant="subtitle1" fontWeight={600} mb={2}>
          Crescimento ao longo do tempo
        </Typography>
        <ResponsiveContainer width="100%" height={260}>
          <AreaChart data={chartData}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="date" tick={{ fontSize: 11 }} />
            <YAxis tick={{ fontSize: 11 }} />
            <Tooltip />
            <Area
              type="monotone"
              dataKey="sessions"
              stroke="#1976d2"
              fill="#1976d214"
              strokeWidth={2}
            />
          </AreaChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
}
